import { render, staticRenderFns } from "./VsErrorPage.vue?vue&type=template&id=71e9a9e3&lang=pug&"
import script from "./VsErrorPage.vue?vue&type=script&lang=js&"
export * from "./VsErrorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71e9a9e3')) {
      api.createRecord('71e9a9e3', component.options)
    } else {
      api.reload('71e9a9e3', component.options)
    }
    module.hot.accept("./VsErrorPage.vue?vue&type=template&id=71e9a9e3&lang=pug&", function () {
      api.rerender('71e9a9e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsErrorPage.vue"
export default component.exports